const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : ScheduledRestartController
 */

function ScheduledRestartController(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

ScheduledRestartController.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_ScheduledRestartController = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const ScheduledRestartController_null_Idle = new StateJS.State('Idle', this._statemachine).entry(() => {
    this.ScheduledRestartController_autoRestartCount_var = 0;
  });
  const ScheduledRestartController_null_Ready = new StateJS.State('Ready', this._statemachine);
  const ScheduledRestartController_null_SheduleRestart = new StateJS.State('SheduleRestart', this._statemachine).entry(() => {
    this.bus.emit('timer', new Event.Timer_start_TimerMsgs(this.name, 'timer', this.ScheduledRestartController_scheduledRestartControllerTimerId_var, this.adjustBackoff()));
  }).exit(() => {
    this.bus.emit('timer', new Event.Timer_cancel_TimerMsgs(this.name, 'timer', this.ScheduledRestartController_scheduledRestartControllerTimerId_var));
  });
  _initial_ScheduledRestartController.to(ScheduledRestartController_null_Idle);
  ScheduledRestartController_null_SheduleRestart.to(ScheduledRestartController_null_Ready).on(Event.Timer_timeout_TimerMsgs).when((timer_timeout) => timer_timeout.port === 'timer' && timer_timeout.type === 'timer_timeout' && (timer_timeout.id === this.ScheduledRestartController_scheduledRestartControllerTimerId_var)).effect((timer_timeout) => {
    if (this.ScheduledRestartController_autoRestartEnabled_var && !(this.ScheduledRestartController_keepAliveWarning_var)) {
      this.ScheduledRestartController_autoRestartCount_var += 1;
      if (this.ScheduledRestartController_autoRestartCount_var < this.ScheduledRestartController_maxAutoRestartCount_var) {
        this.bus.emit('statusInput', new Event.AutoRestartCount_StatusMsg(this.name, 'statusInput', this.ScheduledRestartController_autoRestartCount_var));
        this.bus.emit('videoControl', new Event.Restart_VideoControllerMsg(this.name, 'videoControl'));
      } else {
        this.bus.emit('videoControl', new Event.Stop_VideoControllerMsg(this.name, 'videoControl'));
      }
    }
  });
  ScheduledRestartController_null_Ready.to(ScheduledRestartController_null_SheduleRestart).on(Event.Restart_VideoControllerMsg).when((restart) => restart.port === 'controllers' && restart.type === 'restart');
  ScheduledRestartController_null_SheduleRestart.to(ScheduledRestartController_null_Idle).on(Event.Stopped_VideoControllerMsg).when((stopped) => stopped.port === 'videoControl' && stopped.type === 'stopped');
  ScheduledRestartController_null_Idle.to(ScheduledRestartController_null_Ready).on(Event.Playing_VideoControllerMsg).when((playing) => playing.port === 'videoControl' && playing.type === 'playing');
  this._statemachine.on(Event.KeepAliveWarning).when((keepAliveWarning) => keepAliveWarning.port === 'keepalive' && keepAliveWarning.type === 'keepAliveWarning').effect((keepAliveWarning) => {
    this.ScheduledRestartController_keepAliveWarning_var = keepAliveWarning.status;
  });
};
ScheduledRestartController.prototype.timestamp = function () {
  return Date.now();
};

ScheduledRestartController.prototype.setAutoRestart = function (ScheduledRestartController_setAutoRestart_autoRestart_var) {
  this.ScheduledRestartController_autoRestartEnabled_var = ScheduledRestartController_setAutoRestart_autoRestart_var;
};

ScheduledRestartController.prototype.adjustBackoff = function () {
  if (this.ScheduledRestartController_gracePeriod_var < this.ScheduledRestartController_maxGracePeriod_var) {
    /* eslint-disable-next-line operator-assignment */
    this.ScheduledRestartController_gracePeriod_var = 2 * this.ScheduledRestartController_gracePeriod_var + Math.floor(Math.random() * 1000);
    if (this.ScheduledRestartController_gracePeriod_var > this.ScheduledRestartController_maxGracePeriod_var) {
      this.ScheduledRestartController_gracePeriod_var = this.ScheduledRestartController_maxGracePeriod_var + Math.floor(Math.random() * 10000);
    }
  }
  return this.ScheduledRestartController_gracePeriod_var;
};

ScheduledRestartController.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

ScheduledRestartController.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

ScheduledRestartController.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

ScheduledRestartController.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

ScheduledRestartController.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tmaxAutoRestartCount = ${this.ScheduledRestartController_maxAutoRestartCount_var}`;
  result += `\n\tautoRestartCount = ${this.ScheduledRestartController_autoRestartCount_var}`;
  result += `\n\tkeepAliveWarning = ${this.ScheduledRestartController_keepAliveWarning_var}`;
  result += `\n\tgracePeriod = ${this.ScheduledRestartController_gracePeriod_var}`;
  result += `\n\tscheduledRestartControllerTimerId = ${this.ScheduledRestartController_scheduledRestartControllerTimerId_var}`;
  result += `\n\tautoRestartEnabled = ${this.ScheduledRestartController_autoRestartEnabled_var}`;
  result += `\n\tmaxGracePeriod = ${this.ScheduledRestartController_maxGracePeriod_var}`;
  result += '';
  return result;
};

module.exports = ScheduledRestartController;
